import Config from '../../../config/Config'
import { mergeMap, map, catchError, withLatestFrom } from 'rxjs/operators'
import { of } from 'rxjs'
import { ajax } from 'rxjs/ajax'
import { ofType } from 'redux-observable'
import queryString from '@promoboxx/query-string-babel'
import { headersSelector } from '../../auth/selectors'
import { rootCatchError } from '../../../lib/Utils'
import * as actions from '../actions'

const buildSearchCampaignsParams = (payload) => {
  const {
    perPage,
    offset = 0,
    search,
    sortColumn,
    sortDirection,
    filters,
    filtersObject,
    tags,
    fields,
  } = payload
  let params = queryString.stringify(
    {
      per_page: perPage,
      offset,
      search,
      sort_column: sortColumn,
      sort_direction: sortDirection,
      filters: JSON.stringify(filters),
      tags,
      fields,
    },
    { arrayFormat: 'bracket' },
  )
  
  //Special handling for filters objects.
  //Query params can look like this: filters=<hash>&filters[key]=value
  //Of course the name of the param (filters) interferes with itself and need
  //special handling.
  if (filtersObject) {
    let filtersParams = []
    Object.keys(filtersObject).map(key => {
      filtersParams.push(`filters[${key}]=${filtersObject[key]}`)
    })
    params = `${params}&${filtersParams.join('&')}`
  }

  if (params) {
    params = `?${params}`
  }
  
  return params
}

export const getCampaignsObservable = ([action, state]) => {
  const headers = headersSelector(state)
  const { resourceType, resourceId, params = {} } = action.payload

  if (!headers) {
    throw new Error('Bad or Non-existent auth headers')
  }

  if (!resourceType) {
    throw new Error('payload.resourceType is required')
  }

  if (!resourceId) {
    throw new Error('payload.resourceId is required')
  }

  const queryParams = buildSearchCampaignsParams(params)

  const settings = {
    method: 'GET',
    responseType: 'json',
    headers,
    url: `${Config.API_BASE}/v2/${resourceType}/${resourceId}/campaigns${queryParams}`,
  }
  
  return ajax(settings).pipe(
    map((payload) => {
      return {
        type: actions.GET_CAMPAIGNS_FULFILLED,
        payload: {
          response: payload.response,
          resourceType,
          resourceId,
        },
      }
    }),
    catchError((payload) => {
      return of({
        type: actions.GET_CAMPAIGNS_REJECTED,
        payload: {
          response: payload.response,
          resourceType,
          resourceId,
        },
      })
    }),
  )
}

export const getCampaignsEpic = (action$, state$) => {
  return action$.pipe(
    ofType(actions.GET_CAMPAIGNS),
    withLatestFrom(state$),
    mergeMap(getCampaignsObservable),
    rootCatchError(actions.GET_CAMPAIGNS_REJECTED),
  )
}
